import React, { useCallback } from 'react';
import CheckboxMark from '../../common/CheckboxMark';
import SafeImage from '../../../../../elements/SafeImage/SafeImage';
import styles from './SelectableLocationListItem.module.scss';

function SelectableLocationListItem(props) {
    const { className = '', location, selected, onClick } = props;

    const handleClick = useCallback(() => {
        if (onClick) onClick(location);
    }, [location, onClick]);

    return (
        <div className={[styles.SelectableLocationListItem, className].join(' ')} onClick={handleClick}>
            <CheckboxMark checked={selected} />
            <div className={styles.name}>{location.name}</div>
            {location.image_url ? <SafeImage className={styles.img} src={location.image_url} /> : null}
        </div>
    );
}

export default SelectableLocationListItem;
